import { useEffect, useState } from 'react'

export default function ImageCatalog({ service, api }) {
  const [images, setImages] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setImages([]); setError('')
    if (!service?.service_id) return undefined
    const controller = new AbortController()
    setLoading(true)
    api(`/services/${encodeURIComponent(service.service_id)}/images`, { signal: controller.signal })
      .then(body => {
        if (body.readOnly !== true || body.deploymentEnabled !== false || !Array.isArray(body.images)) {
          throw Error('이미지 조회 결과를 검증할 수 없습니다.')
        }
        setImages(body.images)
      })
      .catch(cause => { if (cause.name !== 'AbortError') setError(cause.message) })
      .finally(() => { if (!controller.signal.aborted) setLoading(false) })
    return () => controller.abort()
  }, [service?.service_id, api])

  return <section className="deploy-panel" aria-labelledby="image-catalog-heading">
    <h2 id="image-catalog-heading">자체 레지스트리 이미지</h2>
    <p>등록된 이미지의 불변 식별값을 조회합니다. 이 화면에서는 아직 노드 배포를 실행할 수 없습니다.</p>
    {!service && <p>서비스를 먼저 선택하세요.</p>}
    {service && loading && <p role="status">이미지를 확인하는 중입니다.</p>}
    {service && error && <p className="deploy-error" role="alert">{error}</p>}
    {service && !loading && !error && images.length === 0 && <p>조회 가능한 이미지가 없습니다.</p>}
    {service && images.length > 0 && <ul className="deploy-images">{images.map(image =>
      <li key={`${image.repository}@${image.digest}`}>
        <strong>{image.repository}:{image.tag}</strong>
        <code>{image.digest}</code>
      </li>)}</ul>}
  </section>
}
